<script>
  import options from './PIMap.options'
  export default options
</script>

<template>
  <article class="nyk-pi-map" :class="{ 'nyk-pi-map--hidden-mobile': !showMapsMobile }">

    <div class="nyk-pi-map__map-search-section">
      <div class="nyk-pi-map__controls">

        <div class="nyk-pi-map__controls__search">
            <div class="nyk-form nyk-js--form">
              <div class="nyk-form__content">
                  <input
                      ref="googlePlacesSearchField"
                      class="nyk-form__content__input"
                      type="text"
                      maxlength="10000"
                      autocomplete="off"
                      id="googlePlacesSearch"
                      name="googlePlacesSearch"
                      aria-haspopup="true"
                      :aria-expanded="googlePlacesSearchResultsShown"
                      role="combobox"
                      aria-controls="googlePlacesSearchResults"
                      @keydown.enter="handleSearch"
                      aria-required="true" />
                  <label for="googlePlacesSearch" class="nyk-form__content__label">{{ labels.searchPlaceholderLabel }}</label>

                  <button
                      @click="resetSearch"
                      class="nyk-form__content__reset-icon nyk-form-js--reset"
                      aria-label="Slet indtastning">
                      <span class="nyk-icon nyk-icon--ui-close"></span>
                  </button>
              </div>
          </div>
        </div>
        
        <div class="nyk-form nyk-js--form nyk-form--select">
            <div class="nyk-form--select__content">
              <select
                class="nyk-form--select__content__select"
                name="availableBanks"
                id="availableBanksId"
                ref="availableBankRef"
                v-on:change="handleBankChange"
              >
                <option v-for="bank, index in availableBanks" :key="index" :value="bank.value">{{ bank.name }}</option>
              </select>
              <label for="availableBanksId" class="nyk-form--select__content__label">{{ labels.bankSelectorLabel }}</label>
              <div class="nyk-form--select__content__error-icon">
                <span class="nyk-icon nyk-icon--ui-form-error"></span>
              </div>
            </div>
        </div>

      </div>

      <div class="nyk-pi-map__switch-view-mobile">
        <div class="nyk-pi-map__switch-view-mobile__body">
            <button
                v-on:click="handleShowMapMobile"
                class="nyk-pi-map__switch-view-mobile__body__item"
                :class="{ 'nyk-pi-map__switch-view-mobile__body__item--active': showMapsMobile }">
                <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 18">
                    <path fill="#fff" d="M7.25 12.127 4.123 9l-1.065 1.057L7.25 14.25l9-9-1.057-1.058-7.943 7.935Z" />
                </svg>
                Kort
            </button>
            <button
                v-on:click="handleShowListResultsMobile"
                class="nyk-pi-map__switch-view-mobile__body__item"
                :class="{ 'nyk-pi-map__switch-view-mobile__body__item--active': !showMapsMobile }">
                Liste
                <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 18">
                    <path fill="#fff" d="M7.25 12.127 4.123 9l-1.065 1.057L7.25 14.25l9-9-1.057-1.058-7.943 7.935Z" />
                </svg>
            </button>
        </div>
      </div>

      <div class="nyk-pi-map__zoom-level" aria-live="polite">Zoom level: {{ currentZoom }}</div>
      <div class="nyk-pi-map__map-section">
        <div
          class="nyk-pi-map__map-section__suggestions"
          :class="{ 'nyk-pi-map__map-section__suggestions--shown': showFilteredResults }">
          
          <MapSuggestions 
            v-if="centerInformationFiltered.length > 0 && !selectedBank && !availableBankSelected?.external && !noDirectResults"
            :suggestions="centerInformationFiltered"
            :showListCount="showListMobileCount"
            :handleCenterClick="handleCenterClick" />

          <SelectedBank
            v-if="selectedBank"
            :selectedBank="selectedBank"
            :navigateBack="unSelectBank"
            :labels="labels" 
            :trackActionCallback="trackEvent"
          />

          <ResultMessage 
            v-if="availableBankSelected?.external"
            :navigateBack="resetFilialFilter"
            :labels="labels"
            :title="availableBankSelected.name"
            :description="labels.externalBankDescription"
          />

          <ResultMessage 
            v-if="noDirectResults && !availableBankSelected?.external"
            :navigateBack="resetAll"
            :labels="labels"
            :title="labels.noResultsTitle"
            :description="labels.noResultsDescription"
          />

        </div>

        <GoogleMapsWithMarkers
          :focusPoints="focusPoints"
          :locations="centerInformationFiltered"
          @current-zoom="updateCurrentZoom"
          theme="totalkreditTheme"
          :isTotalkredit="true"
          :clickLocation="handleCenterClick"
          :startLatitude="startLatitude"
          :startLongitude="startLongitude"
          :mapkey="mapkey" />

      </div>
    </div>
  </article>
</template>
